import UsersPage from "../users/UsersPage";

export default UsersPage;
